// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowPreview-cls1_tl3","cls2":"BulkFollowPreview-cls2_iNE BulkFollowPreview-cls1_tl3","compact":"BulkFollowPreview-compact_iGT"};